export default __webpack_public_path__ + "static/media/Auditing.eba6a549.jpg";